export const NAVIGATION_BEHAVIOUR_PAGE = 'page';
export const NAVIGATION_BEHAVIOUR_ITEM = 'item';

export const SCROLL_BEHAVIOUR_SMOOTH = 'smooth';
export const SCROLL_BEHAVIOUR_AUTO = 'auto';
